import { gql } from '@apollo/client';
const REMOVE_SIZE_STANDARD_SIZE_NAME = gql `
  mutation RemoveSizeStandardSizeName($modelSpecificationSizeNameId: ID!) {
    removeModelSpecificationSizeName(modelSpecificationSizeNameId: $modelSpecificationSizeNameId) {
      removed
    }
  }
`;
export default REMOVE_SIZE_STANDARD_SIZE_NAME;
